import React, { useState, useEffect } from 'react';
import Header from '../common/atoms/Header';
import DashboardSidebar from '../common/atoms/DashboardSidebar';
import { service } from '../../services/AxiosServices';
import { useAuth } from '../../context/AuthContext';
import { useTheme } from  "../../context/ThemeContext"
import { useLocation } from 'react-router-dom';
interface MainLayoutProps {
  children: React.ReactNode;
  sidebarType?: 'dashboard' | 'history';
  excludeSidebar?: boolean;
}

interface Permission {
  create: boolean;
  read: boolean;
  update: boolean;
  delete: boolean;
}

interface RolePermissions {
  [role: string]: {
    [permissionName: string]: Permission;
  };
}

interface UserResponse {
  roles: string[];
  permissions: {
    [role: string]: {
      [permission: string]: {
        can_create: boolean;
        can_read: boolean;
        can_update: boolean;
        can_delete: boolean;
      };
    };
  };
}

const MainLayout: React.FC<MainLayoutProps> = ({ children, sidebarType, excludeSidebar }) => {
  const { user,dispatch } = useAuth();
  const { isDarkMode, toggleTheme } = useTheme();
  const location = useLocation()
  const isAISpace = location.pathname.includes('/ai_space')
  useEffect(() => {
    const fetchUser = async () => {
      try {
        const userId = localStorage.getItem('user');
       
        if (!userId) {
          console.error("No user ID found in local storage.");
          return;
        }
    
        const formData = new FormData();
        formData.append('user', userId.toString());
    
        const response = await service<UserResponse>('/get-role-permissions-of-user/', 'post', formData, 
          'multipart/form-data', 
        );
        
        if (!response.data || !response.data.roles) {
          console.error("Invalid user data received:", response.data);
          return;
        }
  
        const transformedPermissions: RolePermissions = Object.entries(response.data.permissions).reduce(
          (acc, [role, permissions]) => {
            acc[role] = Object.entries(permissions).reduce((permAcc, [permissionName, permission]) => {
              permAcc[permissionName] = {
                create: permission.can_create,
                read: permission.can_read,
                update: permission.can_update,
                delete: permission.can_delete,
              };
              return permAcc;
            }, {} as { [permissionName: string]: Permission });
  
            return acc;
          },
          {} as RolePermissions
        );
        // Update the user context
        dispatch({
          type: 'USER',
          payload: { userData: { roles: response.data.roles, permissions: transformedPermissions } },
        });
  
 
        try {
          const userAccountString = localStorage.getItem('user_account');
          if (userAccountString) {
            const userAccount = JSON.parse(userAccountString);
            
     
            userAccount.roles = response.data.roles;
            userAccount.permissions = transformedPermissions;
    
            localStorage.setItem('user_account', JSON.stringify(userAccount));
          }
        } catch (error) {
          console.error("Error updating user account in localStorage:", error);
        }
      } catch (err) {
        console.error("Error fetching user data:", err);
      }
    };
  
    fetchUser();
  }, []);
  return (
    <div>
      <Header />
      <div className={isAISpace && isDarkMode ? 'bg-dark-mode' : 'bg-light-mode'}>

        <div className="main overflow-auto">
          <div className="row h-100 m-0 overflow-auto">
            {!excludeSidebar && (
              <div className="col-2 ps-0 h-100 overflow-auto">
                {sidebarType !== 'history' && <DashboardSidebar />}
              </div>
            )}
            <div className={`${excludeSidebar ? 'col-12' : 'col-10'} overflow-auto h-100 ps-0`}>
              {children}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MainLayout;
